import pwaConfig from "@/client/applications/meitavlp/pwaConfig.js";

export default {
  waitForServerConfig: true,
  waitForServerLanguage: true,
  themeColor: pwaConfig.themeColor,
};
